(() => {
  if (window.dlPromotionTrackingReady) return;
  window.dlPromotionTrackingReady = true;
  const key = 'dl.pendingPromotion.v1';
  const destination = 'G-5NWSY73ZBN';
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const send = (params) => {
    if (!allowed() || typeof window.gtag !== 'function') return false;
    window.gtag('event', 'select_promotion', { ...params, send_to: destination });
    return true;
  };
  // On ordinary navigation, send on the destination page so the Google tag has
  // time to dispatch. Only consented, non-personal promotion data lives here.
  let attempts = 0;
  let retry;
  const flush = () => {
    window.clearTimeout(retry);
    try {
      const raw = window.sessionStorage.getItem(key);
      if (!raw) return;
      const pending = JSON.parse(raw);
      if (!pending || !Number.isFinite(pending.at) || Date.now() - pending.at > 60000 ||
          pending.params?.promotion_id !== 'home_charm_20260916' ||
          pending.params?.items?.[0]?.item_id !== '15193708593522') {
        window.sessionStorage.removeItem(key);
        return;
      }
      if (window.location.pathname !== pending.path) return;
      if (send(pending.params)) {
        window.sessionStorage.removeItem(key);
      } else if (++attempts < 20) {
        retry = window.setTimeout(flush, 500);
      }
    } catch { /* Storage or analytics failure must never affect shopping. */ }
  };
  const track = (event) => {
    if (event.type === 'auxclick' && event.button !== 1) return;
    const link = event.target?.closest?.('a[data-dl-promotion]');
    if (!link || event.defaultPrevented) return;
    try {
      if (!allowed()) return;
      const data = link.dataset;
      const params = {
        promotion_id: data.promotionId,
        promotion_name: data.productName,
        creative_slot: data.promotionSlot,
        items: [{ item_id: data.productId, item_name: data.productName, price: Number(data.productPrice), currency: data.productCurrency }],
      };
      const query = new URLSearchParams(window.location.search);
      if (query.get('utm_source') === 'workbench' && query.get('utm_medium') === 'qa') {
        params.debug_mode = true;
        params.traffic_type = 'internal';
      }
      const ordinaryClick = event.type === 'click' && event.button === 0 &&
        !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey &&
        !link.hasAttribute('download') && (!link.target || link.target === '_self');
      if (ordinaryClick) {
        try {
          window.sessionStorage.setItem(key, JSON.stringify({ at: Date.now(), path: new URL(link.href).pathname, params }));
        } catch { send(params); }
      } else {
        send(params);
      }
    } catch { /* Preserve the link's native navigation in every failure mode. */ }
  };
  document.addEventListener('click', track);
  document.addEventListener('auxclick', track);
  document.addEventListener('visitorConsentCollected', flush);
  try {
    if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], flush);
    }
  } catch { /* Retry below if the privacy API is still loading. */ }
  flush();
})();
